import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
var UnmountProductTileContext = /*#__PURE__*/ createContext({
    onUnmount: function() {}
});
export var UnmountProductTileProvider = function(param) {
    var onUnmount = param.onUnmount, children = param.children;
    var value = useMemo(function() {
        return {
            onUnmount: onUnmount
        };
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ _jsx(UnmountProductTileContext.Provider, {
        value: value,
        children: children
    });
};
export var useUnmountProductTileContext = function() {
    return useContext(UnmountProductTileContext);
};
